export default __webpack_public_path__ + "../images/android-chrome-192x192.png";